import { companies } from '../../api'
import { store } from '..'
import { setAlert, setIsLoading } from '../components/components-slice'
import { updateUser } from '../user/hook'
import { useMutation, useQuery } from '@tanstack/react-query'
import { setCompany } from './reducer'
import { queryClient } from '../..'
import { setToken, setUser } from '../user/user-slice'
import moment from 'moment'

export function useGenerateOtp() {
  return useMutation(
    (payload) => {
      store.dispatch(setIsLoading(true))
      return companies.generateCompanyOtp(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        // console.log(response)
        store.dispatch(setAlert(true, 'success', response.message))
      },
      onSettled: (response, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

export function useConfirmOtp() {
  return useMutation(
    (payload) => {
      store.dispatch(setIsLoading(true))
      return companies.confirmCompanyOtp(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        store.dispatch(setUser(response.data))
        store.dispatch(setCompany(response.data.company))
        store.dispatch(setAlert(true, 'success', 'Company Added Successfully'))
        window.location.reload()
      },
      onSettled: (response, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

export function useAddCompany() {
  return useMutation(
    (payload) => {
      store.dispatch(setIsLoading(true))
      return companies.addCompany(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        store.dispatch(setUser(response.data))
        store.dispatch(setCompany(response.data.company))
        store.dispatch(setAlert(true, 'success', 'Company Added Successfully'))
        window.location.reload()
      },
      onSettled: (response, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

export function useGetUserCompanies() {
  return useQuery(['user-companies'], companies?.getUserCompanies)
}

export function useSwitchCurrentCompany() {
  return useMutation(
    (payload) => {
      return companies?.switchCompany(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        updateUser({ reload: true })
        store.dispatch(setAlert(true, 'success', response.message))
      },
    },
    {
      onSettled: (response, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

export function useGetNotificationCount() {
  return useQuery(
    ['notification-count'],
    () => {
      store.dispatch(setIsLoading(true))
      return companies.notificationCount()
    },
    {
      onSettled: () => {
        store.dispatch(setIsLoading(false))
      },
      // keepPreviousData: true
    }
  )
}

export function useGetAllNotifications(limit, page, search) {
  return useQuery(
    ['all-notifications', { limit, page, search }],
    () => {
      store.dispatch(setIsLoading(true))
      return companies.getAllNotifications({
        limit,
        page,
        search,
      })
    },
    {
      select(data) {
        data?.data?.forEach((notification) => {
          notification.created = moment(notification.created).format(
            'MMMM D, YYYY'
          )
          notification.computedActions = [0]
        })
        return data
      },
    }
  )
}

export function useGetBirthdayNotifications() {
  return useQuery(
    ['birthday-notifications'],
    () => {
      store.dispatch(setIsLoading(true))
      return companies.getBirthdayNotifications()
    },
    {
      select(data) {
        data?.forEach((birthday) => {
          birthday.created = moment(birthday.created).format('MMMM D')
          birthday.computedActions = [0]
        })
        return data
      },
    }
  )
}

export function useOpenNotification() {
  return useMutation(
    (payload) => {
      store.dispatch(setIsLoading(true))
      return companies.openNotification(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        queryClient.invalidateQueries('all-notifications')
        store.dispatch(setAlert(true, 'success', response.message))
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

export function useSendWish() {
  return useMutation(
    (payload) => {
      store.dispatch(setIsLoading(true))
      return companies.sendBirthdayWish(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        store.dispatch(setAlert(true, 'success', response.message))
      },
      onSettled: (response, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}
